/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import { connect } from 'react-redux';
import { Slider, DatePicker, Pagination } from 'antd';
import { formatNumber } from '@/utils/utils';
import EncodeUrl from '@/utils/encode';
import Cascaderprovinces from '@/componentWebs/Common/Cascaderprovinces';
import KhachSanComponent from '@/componentWebs/vietnamTickets/KhachSanComponent';
import TourComponent from '@/componentWebs/vietnamTickets/TourComponent';
import ComboComponent from '@/componentWebs/vietnamTickets/ComboComponent';
import VisaComponent from '@/componentWebs/vietnamTickets/VisaComponent';

// import 'moment/locale/vi_VN';
// import locale from 'antd/';

import moment from 'moment';

const listArrTab = [
  {
    id: 'tour',
    text: 'Tour',
  },
  {
    id: 'combo',
    text: 'Combo',
  },
  {
    id: 'hotel',
    text: 'Khách sạn',
  },
  {
    id: 'visa',
    text: 'Khách sạn',
  },
];

moment.locale('vi');

const pageSize = 20;
const { RangePicker } = DatePicker;

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTabs: 'tour',
      typeTab: props.typeTab,
      diaChi: props.diaChi || [],
      key: Math.random(),
      textCountries: props.textCountries || '',
      textProvinces: props.textProvinces || '',
      isInternational: props.isInternational || '',
      typeInternational: props.typeInternational,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { isInternational, diaChi, textCountries, textProvinces } = this.props;
    if (nextProps.isInternational !== isInternational) {
      this.setState({
        isInternational: nextProps.isInternational,
        key: Math.random(),
      });
    }
    if (nextProps.textCountries !== textCountries) {
      this.setState({
        textCountries: nextProps.textCountries,
        key: Math.random(),
      });
    }
    if (nextProps.textProvinces !== textProvinces) {
      this.setState({
        textProvinces: nextProps.textProvinces,
        key: Math.random(),
      });
    }
  }

  render() {
    // const { data } = this.props;
    const {
      activeTabs,
      typeTab,
      diaChi,
      key,
      isInternational,
      textCountries,
      textProvinces,
      typeInternational,
    } = this.state;
    // console.log("textCountries aaaa: ", diaChi,);
    // console.log('typeInternational: ', typeInternational);

    const newListTab =
      Number(typeInternational) === 0
        ? [
          {
            id: 'tour',
            text: 'Tour',
          },
          {
            id: 'combo',
            text: 'Combo',
          },
          {
            id: 'hotel',
            text: 'Khách sạn',
          },
        ]
        : [
          {
            id: 'tour',
            text: 'Tour',
          },
          {
            id: 'combo',
            text: 'Combo',
          },
          {
            id: 'hotel',
            text: 'Khách sạn',
          },
          {
            id: 'visa',
            text: 'Visa',
          },
        ];

    return (
      // Tin tức trang chủ
      <React.Fragment>
        <div className="khachSanDetail_dexuat">
          <div className="khachSanDetail_dexuat__main">
            <ul className="khachSanDetail_dexuat__tabs flex-a-c">
              {newListTab &&
                newListTab.length > 0 &&
                newListTab.map(item => (
                  <li
                    className={activeTabs === item.id ? 'active' : ''}
                    key={item.id}
                    onClick={() =>
                      this.setState({
                        activeTabs: item.id,
                        key: Math.random(),
                      })
                    }
                  >
                    {`${item.text}`}
                  </li>
                ))}
            </ul>
            <div className="khachSanDetail_dexuat__content">
              {activeTabs === 'tour' && (
                <TourComponent
                  key={key + 1}
                  travelTourDestinationLocations={diaChi}
                  isInternational={isInternational}
                  textProvinces={textProvinces}
                  typeTab
                />
              )}

              {activeTabs === 'hotel' && (
                <KhachSanComponent
                  isInternational={isInternational}
                  textProvinces={textProvinces}
                  key={key + 2}
                  diaDiem={diaChi}
                  typeTab
                />
              )}

              {activeTabs === 'combo' && (
                <ComboComponent
                  key={key + 3}
                  travelTourDestinationLocations={diaChi}
                  isInternational={isInternational}
                  textProvinces={textProvinces}
                  typeTab
                />
              )}
              {activeTabs === 'visa' && (
                <div className="container-normal">
                  <VisaComponent
                    key={key + 4}
                    diaDiem={[diaChi[0]]}
                    textCountries={textCountries}
                    isSearch
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Index;
